/**
 * Rebuilds a failed exchange reported by the flow token page as the error the
 * exchange would have rejected with, so that it is reported by the same rule as
 * a failure inside the dashboard.
 *
 * @param {String} outcome - the response status, or `timeout` or `network`
 *   when no response arrived
 *
 * @returns {Error} carrying a `response` with the status, when there was one
 */
export default function makeExchangeError(outcome) {
  const error = new Error(`The flow token exchange failed before the dashboard loaded: ${ outcome }`)
  const status = Number(outcome)

  if ( Number.isInteger(status) ) {
    error.response = {
      status,
    }
  }

  return error
}
